import { fromJS } from 'immutable';
import { isString } from '../../../../form/formUtilities';

export const earthquakeSearchModel = fromJS({
  name: 'earthquakeSearchForm',
  initialValues: {
    id: '',
    minYear: '',
    maxYear: '',
    region: '',
    country: '',
    area: '',
    minLatitude: '',
    maxLatitude: '',
    minLongitude: '',
    maxLongitude: '',
    minEqMagnitude: '',
    maxEqMagnitude: '',
    minIntensity: '',
    maxIntensity: '',
    minEqDepth: '',
    maxEqDepth: '',
    minDeaths: '',
    maxDeaths: '',
    minDeathsAmountOrder: '',
    maxDeathsAmountOrder: '',
    minDamageMillionsDollars: '',
    maxDamageMillionsDollars: '',
    minDamageAmountOrder: '',
    maxDamageAmountOrder: '',
    assocVol: '',
    assocTsu: '',
    minDeathsTotal: '',
    maxDeathsTotal: '',
    minDeathsAmountOrderTotal: '',
    maxDeathsAmountOrderTotal: '',

    radios: {
      locationSearchType: 'locInclude',
      loc: '',
      commentsSearchType: 'commentsInclude',
      comments: '',
    },
  },
});


export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      locationSearchType,
      loc,
      commentsSearchType,
      comments,
    },
  } = search;

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  if (commentsSearchType) {
    search[commentsSearchType] = comments;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
